// src/context/Mappings/permissionMap.js

/**
 * Mapa maestro de permisos ↔︎ UI.
 * moduleKey/submoduleKey son los que se guardan en Mongo.
 * Mantén estos keys estables; puedes renombrar etiquetas sin tocar keys.
 */

export const PERMISSION_MAP = [
    {
        moduleKey: "dashboard",
        label: "Dashboard",
        path: "/dashboard",
        submodules: [] // sin submódulos
    },
    {
        moduleKey: "mapeo",
        label: "Mapeo",
        // No es un path único (tienes dos entradas), lo modelamos como submódulos:
        submodules: [
            {
                submoduleKey: "mapeo_maquinaria",
                label: "Mapeo de maquinaria",
                path: "/mapeo?tipo=mapeo_maquinaria"
            },
            {
                submoduleKey: "procesamiento_fotos",
                label: "Procesamiento de fotos",
                path: "/mapeo?tipo=procesamiento_de_fotos"
            }
        ]
    },
    {
        moduleKey: "sig_agricola",
        label: "SIG Agrícola",
        submodules: [
            // Cosecha
            { submoduleKey: "cosecha.planificacion", label: "Planificación de cosecha", path: null },
            { submoduleKey: "cosecha.avance", label: "Avance de cosecha", path: "/cosecha/avance" },
            { submoduleKey: "cosecha.tipo", label: "Tipo de cosecha", path: "/cosecha/tipo" },
            { submoduleKey: "cosecha.traciegos", label: "Traciegos", path: "/cosecha/traciegos" },
            { submoduleKey: "cosecha.quemas", label: "Quemas criminales", path: "/cosecha/quemas" },
            { submoduleKey: "cosecha.rutas", label: "Rutas cañeras", path: "/cosecha/rutas" },

            // Herbicidas
            { submoduleKey: "herbicidas.planificacion", label: "Planificación de Herbicidas", path: null },

            // Madurantes
            { submoduleKey: "madurantes.planificacion", label: "Planificación de madurante", path: "/madurantes/planificacion" },
            { submoduleKey: "madurantes.avance", label: "Avance de madurante", path: "/madurantes/avance" },
            { submoduleKey: "madurantes.dias_programados", label: "Días programados para corte", path: null },
            { submoduleKey: "madurantes.aplicacion_dron", label: "Aplicación con dron", path: "/madurantes/aplicacion-dron" },

            // Variedades
            { submoduleKey: "variedades.tipos", label: "Tipos de variedades", path: "/variedades/tipos" },
            { submoduleKey: "variedades.ranking", label: "Variedades de más a menos productividad", path: null },
            { submoduleKey: "variedades.semilleros", label: "Semilleros", path: "/variedades/semilleros" },
            { submoduleKey: "variedades.ensayos", label: "Ensayos de variedades", path: "/variedades/ensayos" },

            // Plagas
            { submoduleKey: "plagas.barrenador", label: "Barrenador", path: "/plagas/barrenador" },
            { submoduleKey: "plagas.chinche", label: "Chinche salivosa", path: "/plagas/chinche" },
            { submoduleKey: "plagas.rata", label: "Rata", path: null },
            { submoduleKey: "plagas.suelo", label: "Plagas del suelo", path: "/plagas/suelo" },
            { submoduleKey: "plagas.programacion", label: "Programación de muestreo semanal", path: "/plagas/programacion" },

            // Riego
            { submoduleKey: "riego.areas", label: "Áreas con y sin riego", path: "/riego/areas" },
            { submoduleKey: "riego.tipos", label: "Tipos de riego", path: "/riego/tipos" },
            { submoduleKey: "riego.balance", label: "Balance hídrico", path: "/riego/balance" },
            { submoduleKey: "riego.evapotranspiracion", label: "Evapotranspiración", path: "/riego/evapotranspiracion" },
            { submoduleKey: "riego.calidad", label: "Calidad del riego", path: "/riego/calidad" },
            { submoduleKey: "riego.productividad", label: "Productividad con y sin riego", path: null }
        ]
    },
    {
        moduleKey: "historial",
        label: "Historial",
        submodules: [] // se maneja como panel, sin sub-permisos por ahora
    },
    {
        moduleKey: "configuracion",
        label: "Configuración",
        path: "/configuracion",
        submodules: []
    }
];
